<template>
    <div class="main-page" ref="main_page" @touchmove="mainTouchStart" v-if="pageData" >
        <Header :isNavCurrent="0" @videoShowF='videoShowF' />
        <div class="kv">
            <KvSwiper :kvList="pageData.kvList" :canvasWidth="750" :canvasHeight="383" />
        </div>

        <NavPanel :navList="pageData.page2List" />

        <div class="part_two">
            <div class="part_two_title"></div>
            <div class="data">
                <div class="item" :class="'item_' + index" v-for="(item, index) in pageData.friendList">
                    <img :src="item" alt="">
                </div>
                <div class="red red1"></div>
                <div class="red red2"></div>
                <div class="red red3"></div>
                <div class="red red4"></div>
            </div>
        </div>
        <div class="part_three">
            <div class="part_three_title"></div>
            <div class="list">
                <ServerPanel :serverList="pageData.serverList" />
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
import Header from '@/components/header';
import Footer from '@/components/footer';
import KvSwiper from '@/components/kvSwiper';
import ServerPanel from './components/serverPanel';
import NavPanel from './components/navPanel';

export default {
    name: "Index",
    components: {
        Header,
        Footer,
        KvSwiper, ServerPanel,NavPanel
    },
    data() {
        return {
            pageData: null,
            isNavCurrent: 0,
        };
    },
    async created() {
        // 测试环境
        if (window.location.href.indexOf('localhost') >= 0) {
            var res = await this.$post('/test/getPage', { id: 1 });
            var pageData = res.data;
        } else {
            var pageData = orginalJsonData.content;
        }
        for (var k in pageData.page2List) {
            pageData.page2List[k]['active'] = k == 0;
        }
        console.log(pageData);
        this.pageData = pageData;
    },
    mounted() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
        mainTouchStart() {

        },
        videoShowF(value) {

        },
    },
};
</script>
<style scoped lang="scss">
.main-page {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;

    .kv {
        width: 100%;
        height: 8.99rem;
        position: relative;
    }

}


.main-page .part_two {
    width: 100%;
    height: 11.65rem;
    background: #f2f2f2;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.main-page .part_two .part_two_title {
    width: 1.88rem;
    height: 0.66rem;
    background: url(../../assets/index/title1.png) no-repeat;
    background-size: 100% auto;
    margin-top: 1.15rem;
}

.main-page .part_two .data {
    margin-top: 0.8rem;
    position: relative;
    width: 17rem;
    height: 8.9rem;
    display: flex;
    flex-wrap: wrap;
    position: relative;
}

.main-page .part_two .data .item {
    width: 2.55rem;
    height: 2.55rem;
    position: absolute;
}

.main-page .part_two .data .item  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.main-page .part_two .data .item:hover {
    transform: scale(1.1);
    cursor: pointer;

}

.main-page .part_two .data .item_0 {
    left: 2.9rem;
    top: 0.06rem;
}

.main-page .part_two .data .item_1 {
    left: 5.79rem;
    top: 0.09rem;
}

.main-page .part_two .data .item_2 {
    left: 8.74rem;
    top: 0.08rem;
}

.main-page .part_two .data .item_3 {
    left: 11.52rem;
    top: 0.08rem;
}

.main-page .part_two .data .item_4 {
    left: 1.44rem;
    top: 1.48rem;
}

.main-page .part_two .data .item_5 {
    left: 4.38rem;
    top: 1.48rem;
}

.main-page .part_two .data .item_6 {
    left: 5.88rem;
    top: 1.52rem;
    width: 5.31rem;
    height: 5.31rem
}

.main-page .part_two .data .item_7 {
    left: 10.12rem;
    top: 1.46rem;
}

.main-page .part_two .data .item_8 {
    left: 12.93rem;
    top: 1.48rem;
}

.main-page .part_two .data .item_9 {
    left: 2.9rem;
    top: 2.9rem;
}

.main-page .part_two .data .item_10 {
    left: 11.52rem;
    top: 2.9rem;
}

.main-page .part_two .data .item_11 {
    left: 14.38rem;
    top: 2.9rem;
}

.main-page .part_two .data .item_12 {
    left: 1.48rem;
    top: 4.3rem;
}

.main-page .part_two .data .item_13 {
    left: 4.33rem;
    top: 4.3rem;
}

.main-page .part_two .data .item_14 {
    left: 10.11rem;
    top: 4.3rem;
}

.main-page .part_two .data .item_15 {
    left: 12.93rem;
    top: 4.3rem;
}

.main-page .part_two .data .item_16 {
    left: 2.9rem;
    top: 5.69rem;
}

.main-page .part_two .data .item_17 {
    left: 5.76rem;
    top: 5.7rem;
}

.main-page .part_two .data .item_18 {
    left: 8.72rem;
    top: 5.72rem;
}

.main-page .part_two .data .item_19 {
    left: 11.52rem;
    top: 5.68rem;
}

.main-page .part_two .data .red {
    position: absolute;
}

.main-page .part_two .data .red1 {
    left: 14.71rem;
    top: 0.87rem;
    width: 1.71rem;
    height: 1.71rem;
    background: url(../../assets/index/hezuo/img10.png) no-repeat;
    background-size: 100% auto;
}

.main-page .part_two .data .red2 {
    left: 0rem;
    top: 2.91rem;
    width: 2.55rem;
    height: 2.55rem;
    background: url(../../assets/index/hezuo/img11.png) no-repeat;
    background-size: 100% auto;
}

.main-page .part_two .data .red3 {
    left: 1.17rem;
    top: 6.13rem;
    width: 1.49rem;
    height: 1.49rem;
    background: url(../../assets/index/hezuo/img19.png) no-repeat;
    background-size: 100% auto;
}

.main-page .part_two .data .red4 {
    right: 2.23rem;
    top: 6.99rem;
    width: 1.05rem;
    height: 1.05rem;
    background: url(../../assets/index/hezuo/img24.png) no-repeat;
    background-size: 100% auto;
}

.main-page .part_three {
    width: 100%;
    /* height: 9.51rem; */
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.main-page .part_three .part_three_title {
    width: 1.85rem;
    height: 0.65rem;
    background: url(../../assets/index/title2.png) no-repeat bottom center;
    background-size: 100% auto;
    padding-top: 1.22rem;
    margin-bottom: 0.9rem;

}

.main-page .part_three .list {
    width: 100%;
    margin-bottom: .9rem;
    position: relative;
}


@media screen and (max-width: 750px) {
    .main-page .kv {
        width: 100%;
        height: 3.83rem
    }


    .main-page .part_two {
        height: 5.2rem;
    }

    .main-page .part_two .data {
        width: 7.06rem;
        height: 3.45rem;
        margin-top: 0.25rem
    }

    .main-page .part_two .data .item {
        width: 1.06rem;
        height: 1.06rem;
    }

    .main-page .part_two .data .item_0 {
        left: 1.21rem;
        top: 0rem;
    }

    .main-page .part_two .data .item_1 {
        left: 2.41rem;
        top: 0rem;
    }

    .main-page .part_two .data .item_2 {
        left: 3.60rem;
        top: 0rem;
    }

    .main-page .part_two .data .item_3 {
        left: 4.80rem;
        top: 0rem;
    }

    .main-page .part_two .data .item_4 {
        left: 0.56rem;
        top: 0.62rem;
    }

    .main-page .part_two .data .item_5 {

        left: 1.8rem;
        top: 0.62rem;
    }

    .main-page .part_two .data .item_6 {
        width: 2.21rem;
        height: 2.21rem;
        left: 2.43rem;
        top: 0.62rem;
    }

    .main-page .part_two .data .item_7 {
        left: 4.20rem;
        top: 0.62rem;
    }

    .main-page .part_two .data .item_8 {
        left: 5.41rem;
        top: 0.62rem;
    }

    .main-page .part_two .data .item_9 {
        left: 1.2rem;
        top: 1.19rem;
    }

    .main-page .part_two .data .item_10 {
        left: 4.80rem;
        top: 1.19rem;
    }

    .main-page .part_two .data .item_11 {
        left: 6rem;
        top: 1.19rem;
    }

    .main-page .part_two .data .item_12 {
        left: 0.62rem;
        top: 1.79rem;
    }

    .main-page .part_two .data .item_13 {
        left: 1.82rem;
        top: 1.79rem;
    }

    .main-page .part_two .data .item_14 {
        left: 4.2rem;
        top: 1.79rem;
    }

    .main-page .part_two .data .item_15 {
        left: 5.41rem;
        top: 1.79rem;
    }

    .main-page .part_two .data .item_16 {
        left: 1.21rem;
        top: 2.35rem;
    }

    .main-page .part_two .data .item_17 {
        left: 2.41rem;
        top: 2.35rem;
    }

    .main-page .part_two .data .item_18 {
        left: 3.60rem;
        top: 2.35rem;
    }

    .main-page .part_two .data .item_19 {
        left: 4.8rem;
        top: 2.35rem;
    }

    .main-page .part_two .data .red1 {
        left: 6.2rem;
        top: 0.4rem;
        width: 0.71rem;
        height: 0.71rem;
    }

    .main-page .part_two .data .red2 {
        left: -0.05rem;
        top: 1.23rem;
        width: 1.06rem;
        height: 1.06rem;
    }

    .main-page .part_two .data .red3 {
        left: 0.47rem;
        top: 2.56rem;
        width: 0.62rem;
        height: 0.62rem;
    }

    .main-page .part_two .data .red4 {
        left: 5.76rem;
        top: 2.91rem;
        width: 0.44rem;
        height: 0.44rem;

    }

    .main-page .part_two .data .red4 {
        left: 5.76rem;
        top: 2.91rem;
        width: 0.44rem;
        height: 0.44rem;

    }


    .main-page .part_two .part_two_title {
        width: 1.1rem;
        height: 0.51rem;
        background: url(../../assets/index/title1_wap.png) no-repeat;
        background-size: 100% auto;
        margin-top: 0.35rem;
    }

    .main-page .part_three .part_three_title {
        width: 1.08rem;
        height: 0.53rem;
        color: transparent;
        background: url(../../assets/index/title2_wap.png) no-repeat bottom center;
        background-size: 100% auto;
        padding-top: 0.6rem;
        margin-bottom: 0.36rem;
    }


    .main-page .part_three .list {
        margin-bottom: 0.6rem;
        width: 100%;
    }

}
</style>
